import axiosClient from "../../network";

export default class userProfileService {
  static getUserProfile() {
    return axiosClient
      .get("/user/userProfile")
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static updateUserProfile(payload) {
    return axiosClient
      .post("/user/updateProfile", payload)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static updateUserProfileAvatar(payload) {
    return axiosClient
      .post("/user/uploadProfileImage", payload, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static resetPassword(payload) {
    return axiosClient
      .post("/user/changePassword", payload)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static getBalance() {
    return axiosClient
      .get("/getBalance")
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static userBetLimit() {
    return axiosClient
      .get("/sb/betLimit")
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }
}
